import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import QUERY, {
	type main_rightSidePanel_RootQuery,
} from '../ui/__generated__/main_rightSidePanel_RootQuery.graphql';
import { JIRA_HOME_PAGE_RIGHT_SIDE_PANEL } from '../constants.tsx';

const isBroadcastWidgetEnabled = () => false;

export const jiraHomePageRightSidePanelResource: RouteResource<
	PreloadedQuery<main_rightSidePanel_RootQuery, Record<string, unknown>>
> = createRelayResource<main_rightSidePanel_RootQuery>({
	type: JIRA_HOME_PAGE_RIGHT_SIDE_PANEL,
	getQuery: (_, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			cloudId: tenantContext.cloudId,
			broadcastWidgetEnabled: isBroadcastWidgetEnabled(),
		},
		options: { fetchPolicy: 'network-only' },
	}),
});
